import { trackEvent, trackPageView } from 'web-services/GoogleAnalytics';

export const trackSignup = ({ email, from, packageName }) => {
  trackEvent('Customer Conversion', 'User Signup', from);

  if (window.gtag && from === 'Style Quiz') {
    window.gtag('event', 'conversion', {'send_to': 'AW-879442427/EudXCMTK9dABEPvzrKMD'});
  }

  if (from === 'Direct Purchase') {
    trackEvent('Direct Purchase', 'User Signup', packageName);
  }
};

export const trackPackagePurchase = ({
  itemName,
  orderTotal,
  orderNumber
}) => {
  if (window.gtag) {
    window.gtag('event', 'Package Purchase', {
      event_category: 'Customer Conversion',
      event_label: itemName,
      value: orderTotal,
      order_id: orderNumber,
      currency: 'USD'
    });
  }
};

export const trackDirectPackagePurchase = ({
  itemName,
  orderTotal,
  orderNumber,
  isGiftCard
}) => {
  // strip the room number from the package name
  const cleansedPackageName = itemName.replace(/[0-9]/g, '');

  const category = isGiftCard ? 'Gift Card' : 'Direct Purchase';

  if (window.gtag) {
    window.gtag('event', 'Package Purchase', {
      event_category: category,
      event_label: cleansedPackageName,
      value: orderTotal,
      order_id: orderNumber,
      currency: 'USD'
    });
  }
};

export const trackMerchPurchase = ({ orderNumber, displayedInfo }) => {
  if (window.gtag) {
    const {
      displayedShipping,
      displayedTax,
      displayedTotal
    } = displayedInfo;

    // displayed total less shipping and handling
    // should be the total after discounts have been applied
    const totalLessDiscounts = parseFloat(displayedTotal) -
      parseFloat(displayedTax) - parseFloat(displayedShipping);

    window.gtag('event', 'purchase', {
      transaction_id: orderNumber,
      value: totalLessDiscounts.toFixed(2),
      shipping: displayedShipping,
      tax: displayedTax,
      currency: 'USD'
    });
  }
};

// Re-export the common event trackers.
export { trackEvent, trackPageView };
